
import React from 'react'

function ProgressBar({ step }) {
    const $percs = ['25%', '50%', '75%', '85%', '90%', '95%', '100%'];
    let $perc = $percs[0];
    let time;

    switch (step) {
        case 5:
            time = '(5 Minutes Left)';
            $perc = $percs[0];
            break;
        case 6:
            time = '(4 Minutes Left)';
            $perc = $percs[1];
            break;
        case 7:
            time = '(3 Minutes to go)';
            $perc = $percs[2];

            break;
        case 8:
            time = '(2 Minutes to go)';
            $perc = $percs[3];
            break;
        case 9:
            time = '(1 Minute to go)';
            $perc = $percs[4];
            break;
        case 10:
            // time = '(1 Minute to go)';
            $perc = $percs[5];
            break;
        case 11:
            // time = '(1 Minute to go)';
            $perc = $percs[5];
            break;

    }
    return (
        <div className="progress-top">
            <div className="progress" id="progressbar">
                <div className="progress-bar" role="progressbar" style={{ width: $perc }} aria-valuemax="100"></div>
            </div>
            <h4 className="text-center pt-2 progress_title"><span className="percent" id="progressCount">{$perc}</span> Complete <small>{time}</small></h4>
        </div>
    )
}

export default ProgressBar
